import { Box } from '@mui/material'
import React, { FC, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch } from '../../../../../../../store'
import { CompanyPreferencesSelector } from '../../../../../../../store/companyPreferences'
import { TechGrantsActions, TechGrantSelectors } from '../../../../../../../store/technology'
import { KanbanView } from './KanbanView'
import { ListView } from './ListView'
import { EmptyState } from '../../../sharedComponents'
import { EmptyMatchedStateIcon } from '../../../../../../../components/icons'

interface PipelineGrantsProps {
  view: 'list' | 'grid'
}

export const PipelineGrants:FC<PipelineGrantsProps> = ({ view }) => {
  const { projectId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const paging = useSelector(TechGrantSelectors.getPaging)

  const pipelineData = useSelector(TechGrantSelectors.makePipelineGrants)
  const pipelineHasData = useSelector(TechGrantSelectors.makePipelineHasData)
  const pipelineStages = useSelector(CompanyPreferencesSelector.makeGrantPipelineStages)

  const fetchGrants = useCallback(() => {
    if (projectId) {
      const options = {
        params: {
          $limit: paging.limit,
          $skip: paging.skip,
          $sort: `createdAt -1`,
          $includes: 'grant,solicitation',
          $filter: JSON.stringify({
            status: 'selected',
            progressStatus: { $ne: 'submitted' },
          }),
        },
      }

      dispatch(
        TechGrantsActions.fetchGrantsAsync({
          id: projectId,
          options,
        }),
      )
    }
  }, [paging.limit, paging.skip, projectId, dispatch])

  useEffect(() => {
    fetchGrants()
  }, [fetchGrants])

  return (
    <Box>
      {!pipelineHasData && <EmptyState message="You currently don't have any grants in your pipeline." icon={EmptyMatchedStateIcon} />}

      {pipelineHasData && (
        <>
          {view === 'grid' && (
            <KanbanView
              cb={fetchGrants}
              pipelineData={pipelineData}
              pipelineStages={pipelineStages}
            />
          )}

          {view === 'list' && (
            <ListView
              pipelineData={pipelineData}
              pipelineStages={pipelineStages}
              fetchGrants={fetchGrants}
            />
          )}
        </>
      )}
    </Box>
  )
}
